import './Loading.sass';
import imgLoading from '../assets/common/loading.svg';

const Loading = () => {
	return (
		<div className='Loading'>
			<div className='center-wrap'>
				<div className='image-wrap'>
					<img src={imgLoading} alt='UOB' />
				</div>
			</div>
		</div>
	);
};

export default Loading;
